module.exports = __webpack_public_path__ + "img/3023869-94-2.a5285ab4.png";